import React, { useEffect, useState } from 'react';
import { HiSearch } from 'react-icons/hi';
import { FiPlusCircle } from 'react-icons/fi';
import { CiFilter } from 'react-icons/ci';
import { FaAngleLeft } from 'react-icons/fa';
import ProcedureTable from './ProcedureTable';
import CreateProcedureModal from '../Modal/CreateProcedureModal';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';
import { BsFillFolderFill } from 'react-icons/bs';
import { FaSpinner } from 'react-icons/fa';
import { api } from '../../Api-Endpoints/apiEndpoint';
import { createFolderSuccess } from '../../Redux/FolderSlice';
import toast from 'react-hot-toast';
import useFilter from '../../Hooks/useFilter';
import {
  LoadProcedureOnRequest,
  LoadProceduresRequest,
  LoadProceduresRequestEnd,
  SetPreviousRoute,
} from '../../Redux/ProcedureReducer';

const ProcedureListing = ({ params }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openFolderModel, setOpenFolderModel] = useState(false);
  const [folderName, setFolderName] = useState('');
  const [searchText, setSearchText] = useState('');
  const [path, setPath] = useState('');
  const [isSearch, setIsSearch] = useState(false);

  const { previousRoute } = useSelector(
    state => ({
      previousRoute: state.Procedure.previousRoute,
    }),
    shallowEqual
  );
  const handleBack = async () => {
    dispatch(LoadProceduresRequest());
    if (previousRoute.length > 0) {
      const lastRoute = previousRoute[previousRoute.length - 1];
      navigate(lastRoute);
      const route = [...previousRoute.slice(0, -1)];
      dispatch(SetPreviousRoute(route));
      const id = lastRoute.split('/')[2];
      if (id) {
        const { status, data } = await api.get(
          `/procedure/getProcedureByFolderId?id=${id}`
        );
        const fetchedProc = data?.procedures[0]?.procedures || [];
        if (user?.role?.includes('admin')) {
          if (status === 200) {
            dispatch(LoadProcedureOnRequest(fetchedProc));
            navigate(`/procedures/${id}`);
          }
        } else {
          const usersProc = await getProcedureByUserId(user?._id);
          const similarObjects = fetchedProc.filter(fetched =>
            usersProc.some(user => user._id === fetched._id)
          );
          dispatch(LoadProcedureOnRequest(similarObjects));
          navigate(`/procedures/${id}`);
        }
      } else {
      }
    }else{

    }
    dispatch(LoadProceduresRequestEnd());
  };
  const getProcedureByUserId = async id => {
    try {
      const { status, data } = await api.get(
        `/procedure/proceduregetbyuser/${id}`
      );
      if (status === 200) {
        dispatch(LoadProcedureOnRequest(data?.procedures || []));
        return data?.procedures || [];
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const { procedure_on_request, user, procedures, isLoading } = useSelector(
    state => ({
      procedure_on_request: state.Procedure.procedure_on_request,
      user: state.User.user,
      procedures: state.Procedure.procedures,
      isLoading: state.Procedure.isLoading,
    }),
    shallowEqual
  );
  
  useEffect(() => {
  }, [procedures, searchText])

  const filteredProcedures = useFilter(searchText, procedures);
  const filteredProcedureOnRequest = useFilter(
    searchText,
    procedure_on_request
  );
  const filtered =
    path === 'procedures' && searchText !== ''
      ? filteredProcedures
      : filteredProcedureOnRequest;

  const onSearch = e => {
    const { value } = e.target;
    setSearchText(value);

    const procPath = window.location.pathname.split('/').pop();
    setPath(procPath);
    if (procPath === 'procedures' && value !== '') {
      setIsSearch(true);
    } else {
      setIsSearch(false);
    }
  };

  const saveFolder = async () => {
    try {
      const { data, status } = await api.post('/folder/createfolder', {
        name: folderName,
        parent: params?.id,
      });
      if (status == 201) {
        dispatch(createFolderSuccess(data.folder));
        toast.success('Folder created successfully.');
        setOpenFolderModel(false);
      }
    } catch (error) {
      setOpenFolderModel(true);
      console.log(error.message);
      toast.error('Folder not created.');
    }
  };

  return (
    <>
      <div className="p-1 ml-3 space-y-3 h-[50vh]">
        <div className="flex justify-between">
          <div className="flex space-x-3">
            <div className="relative flex items-center w-full  overflow-hidden md:w-96 border border-gray-400 rounded-lg px-3">
              {procedures.length < 1 ? (
                <div className="flex items-center justify-center w-full">
                  <FaSpinner className="animate-spin h-5 w-5 text-gray-500" />
                </div>
              ) : (
                <input
                  className="h-full w-full border-none text-sm outline-none bg-transparent"
                  type="text"
                  id="search"
                  placeholder="Search"
                  value={searchText}
                  onChange={onSearch}
                  disabled={procedures.length === 0}
                />
              )}
              <button className="grid place-items-center h-full w-12 text-gray-300 ">
                <HiSearch className="w-6 h-6 text-gray-400" />
              </button>
            </div>
            <button className="border px-3 py-1 rounded-lg border-gray-400">
              <CiFilter className="w-6 h-6 text-black-400" />
            </button>
          </div>

          <div className="flex gap-2">
            {previousRoute.length > 0 && Object.keys(params).length > 0 ? (
              <button
                onClick={() => handleBack()}
                className="flex justify-center items-center space-x-2 bg-red-500 px-5 py-2 text-white rounded-lg font-semibold"
              >
                <FaAngleLeft className="w-5 h-5" />
                <span>back</span>
              </button>
            ) : null}
            {Object.keys(params).length > 0 &&
              user?.role?.includes('admin') && (
                <button
                  // onClick={() => navigate(`/create-procedure/${params?.id}`)}
                  onClick={() => navigate(`/new-procedure/${params?.id}`)}
                  className="flex justify-center items-center space-x-2 bg-red-500 px-5 py-2 text-white rounded-lg font-semibold"
                >
                  <FiPlusCircle className="w-5 h-5" />
                  <span>Create Procedure</span>
                </button>
              )}
            {user?.role?.includes('admin') && (
              <button
                onClick={() => setOpenFolderModel(true)}
                className="flex justify-center items-center space-x-2 bg-red-500 px-5 py-2 text-white rounded-lg font-semibold"
              >
                <FiPlusCircle className="w-5 h-5" />
                <span>Create Folder</span>
              </button>
            )}
            {/* {Object.keys(params).length == 0 && (
                <button
                  onClick={() => setOpenFolderModel(true)}
                  className="flex justify-center items-center space-x-2 bg-red-500 px-5 py-2 text-white rounded-lg font-semibold"
                >
                  <FiPlusCircle className="w-5 h-5" />
                  <span>Create Folder</span>
                </button>
              )} */}
          </div>
        </div>
        <div className="w-full">
          <ProcedureTable
            params={params}
            user={user}
            filtered={filtered}
            isSearch={isSearch}
            setSearchText={setSearchText}
            searchText={searchText}
            setIsSearch={setIsSearch}
          />
        </div>
        {/* <CreateProcedureModal
          showModal={showModal}
          setShowModal={setShowModal}
        /> */}
      </div>
      <Modal
        isOpen={openFolderModel}
        onRequestClose={() => setOpenFolderModel(false)}
        contentLabel="Example Modal"
        style={{
          content: {
            margin: 'auto',
            borderRadius: '20px',
            padding: 0,
            height: '40vh',
            width: '50vw',
            padding: '5px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
          },
        }}
      >
        <div className="h-[10%] w-[90%] flex gap-2 items-center">
          <BsFillFolderFill /> Create Folder
        </div>
        <div className="h-[100%] w-[90%] flex flex-col justify-center items-center p-5">
          <div className="h-[15%] w-[100%]">
            <input
              type="text"
              value={folderName}
              onChange={e => setFolderName(e.target.value)}
              placeholder="Enter folder name"
              className="h-[100%] w-[100%] border border-black"
            />
          </div>
          <div className="flex justify-end items-center h-[20%] w-[100%]">
            <button
              className="h-[30px] w-[100px] border border-[red-500] rounded-md bg-red-500"
              onClick={saveFolder}
            >
              Save
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ProcedureListing;
